import { Button } from '@immo/ui-kit';
import { useTranslations } from '@/i18n/use-translations';

type SelectAllActionsProps = {
  readonly onSelectAll: () => void;
  readonly onDeselectAll: () => void;
  readonly disabled?: boolean;
};

export function SelectAllActions({ onSelectAll, onDeselectAll, disabled }: SelectAllActionsProps) {
  const t = useTranslations('components.select-all-actions');

  return (
    <div className="flex items-center gap-2">
      <Button type="button" variant="ghost" size="sm" onClick={onSelectAll} disabled={disabled}>
        {t('select-all')}
      </Button>
      <Button type="button" variant="ghost" size="sm" onClick={onDeselectAll} disabled={disabled}>
        {t('deselect-all')}
      </Button>
    </div>
  );
}
